// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			
	}
};

(function () {  
	BoostPFS.inject(this);  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
			 if (!suggestionElement) suggestionElement = this.$uiMenuElement;   
		if (!searchElement) searchElement = this.$element;  
		if (!searchBoxId) searchBoxId = this.id; 
	};

	BoostPFS.prototype.beforeBuildSearchBox = function (id) {

		// Remove theme's instant search events
		var cloneSearchBar = jQ(id).clone();
		jQ(id).replaceWith(cloneSearchBar);      
		
		
		if (Utils.InstantSearch.isFullWidthMobile()) {
			jQ(id).removeAttr('autofocus');
			if (jQ(id).is(':focus')) {
				jQ(id).blur();
			}
		}
	};

	BoostPFS.prototype.afterCloseSuggestionMobile = function(searchBoxId, isCloseSearchBox) {
		// Close theme's search pop up
		if (isCloseSearchBox && window.$ && $.fancybox){
			$.fancybox.close(true);
		}
	};

    // InstantSearchResultItemProduct.prototype.afterRender = function() {    
    //   if (this.hasOwnProperty('data') && this.data !== null) {        
    //     var data = this.data;
    //     var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';        
    //     var localeURLPart = "";
    //     if (hasShopifyRoutes) {            
    //       localeURLPart = Shopify.routes.root.replace(/\/$/, '');        
    //     }
    //     var quickUrl = localeURLPart + '/products/' + data.handle + '?view=boost-integration';        
    //     jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();        
    //     jQ.ajax({            
    //       url: quickUrl,            
    //       success: function(result) {                
    //         try {                    
    //           const res = JSON.parse(result);                    
    //           jQ('.boost-pfs-search-suggestion-item[data-id="' + res.id + '"] .boost-pfs-search-suggestion-product-price').html(res.price_isw.trim());                
    //         } catch (error) {                    
    //           console.log(error);                
    //         }            
    //       }        
    //     });    
    //   }
    // }
})();